import { composeIBAN } from 'ibantools';

type QRPayment = {
  countryCode: string;
  bankAccount: string | undefined;
  variableSymbol: string | undefined;
  amount: number | undefined;
  currency: string;
};

// Builds a Short Payment Descriptor (SPD) QR payment string; BBAN is composed as bank code + padded prefix + padded account number
export const composeQRPayment = (data: QRPayment): string => {
  const prefix = String(
    data.bankAccount?.substring(0, data.bankAccount.indexOf('-')) || '',
  ).padStart(6, '0');
  const account = String(
    data.bankAccount?.substring(
      data.bankAccount.indexOf('-') + 1,
      data.bankAccount.indexOf('/'),
    ) || '',
  ).padStart(10, '0');
  const code = data.bankAccount?.slice(-4) || '0000';

  return String().concat(
    'SPD*1.0',
    '*ACC:',
    composeIBAN({
      countryCode: data.countryCode,
      bban: code + prefix + account,
    })!,
    '*AM:',
    String(data.amount),
    '*CC:',
    data.currency,
    '*X-VS:',
    String(data.variableSymbol),
  );
};

// Masks all but the first 4 and last 4 characters of the IBAN for display
export default function bankAccountFormat(bunkAccount: string) {
  const endOfNumber = bunkAccount.slice(20, 24);
  const startOfNumber = bunkAccount.slice(0, 4);
  const printedBankNumber = `${startOfNumber}-****-****-**-******${endOfNumber}`;

  return printedBankNumber;
}
